const styles = {
	dialogPaper: {
		minWidth: 600,
		maxWidth: 800,
		width: '100%',
		boxShadow: 'unset',
	},
	dialogTitle: {
		padding: '16px 24px',
		display: 'flex',
		justifyContent: 'space-between',
		alignItems: 'center',
	},
	dialogContent: {
		padding: '24px',
	},
	cancelButton: {
		color: '#333',
		backgroundColor: '#C5C5C5',
		'&:hover': {
			backgroundColor: '#d0d0d0',
		},
	},
	dialogActions: {
		padding: '16px 24px',
		justifyContent: 'space-between',
	},
	radioGroup: {
		width: '100%',
	},
	legSection: {
		marginBottom: '32px',
	},
	legHeader: {
		display: 'flex',
		justifyContent: 'space-between',
		alignItems: 'center',
		marginBottom: '8px',
	},
	legTitle: {
		fontSize: '28px',
		fontWeight: 'normal',
	},
	radioLabel: {
		margin: 0,
		'& .MuiFormControlLabel-label': {
			fontSize: '19px',
		},
	},
	subtitle: {
		color: '#666',
		fontSize: '14px',
		marginBottom: '16px',
	},
	legsContainer: {
		display: 'flex',
		flexDirection: 'column',
		gap: '8px',
		marginTop: '16px',
	},
	leg: {
		padding: '28px 19px',
		borderRadius: '4px',
	},
	legOdd: {
		backgroundColor: '#F4F4F4',
		padding: '28px 19px',
		borderRadius: '4px',
	},
	legContent: {
		display: 'flex',
		alignItems: 'flex-start',
		gap: '4rem',
	},
	legInfo: {
		display: 'flex',
		flexDirection: 'column',
		gap: '4px',
	},
	legNumber: {
		fontSize: '14px',
		fontWeight: 'normal',
	},
	legTimes: {
		display: 'flex',
		flexDirection: 'column',
		gap: '4px',
		alignItems: 'flex-end',
	},
	timeText: {
		fontSize: '14px',
		fontWeight: 'normal',
	},
};

export default styles;
